(() => {
  const blocks = () => [...document.querySelectorAll('[data-cart-discount]')];
  let cart, busy = false;
  const root = window.Shopify?.routes?.root || '/';
  function paint(value) {
    cart = value;
    const codes = (cart.discount_codes || []).filter(code => code.applicable);
    blocks().forEach(block => {
      const list = block.querySelector('[data-discount-list]');
      list.replaceChildren();
      codes.forEach(code => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.discountRemove = code.code;
        button.textContent = code.code + ' ×';
        button.setAttribute('aria-label', block.dataset.remove + ' ' + code.code);
        list.append(button);
      });
    });
  }
  async function apply(block, remove) {
    if (busy) return;
    const input = block.querySelector('[data-discount-input]');
    const entered = input.value.trim();
    if (remove === undefined && !entered) { input.focus(); return; }
    busy = true;
    document.querySelectorAll('.cart-page__accelerated').forEach(el => el.inert = true);
    const status = block.querySelector('[data-discount-status]');
    status.textContent = block.dataset.saving;
    blocks().forEach(b => b.querySelectorAll('button').forEach(btn => btn.disabled = true));
    try {
      await window.CartujaGiftCard?.flush();
      document.querySelectorAll('.cart-page__accelerated').forEach(el => el.inert = true);
      const current = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!current.ok) throw new Error('Cart unavailable');
      const before = await current.json();
      let codes = (before.discount_codes || []).filter(c => c.applicable).map(c => c.code);
      codes = remove === undefined ? [...new Set([...codes, entered])] : codes.filter(c => c.toLowerCase() !== remove.toLowerCase());
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      });
      if (!response.ok) throw new Error('Discount update failed');
      const result = await response.json();
      const accepted = remove !== undefined || (result.discount_codes || []).some(c => c.applicable && c.code.toLowerCase() === entered.toLowerCase());
      paint(result);
      status.textContent = accepted ? (remove === undefined ? block.dataset.applied : '') : block.dataset.invalid;
      document.dispatchEvent(new CustomEvent('cartuja:discount-update', { detail: result }));
      if (accepted && document.querySelector('[data-cart-page]')) window.location.reload();
      if (accepted) input.value = '';
    } catch (_) { status.textContent = block.dataset.error; }
    finally {
      busy = false;
      document.querySelectorAll('.cart-page__accelerated').forEach(el => el.inert = false);
      blocks().forEach(b => b.querySelectorAll('button').forEach(btn => btn.disabled = false));
    }
  }
  document.addEventListener('submit', e => {
    if (busy && e.target.matches('.cart-page__form')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', e => {
    if (!busy) return;
    const target = e.target.closest('a, button');
    if (target && target.closest('#cartDrawer, [data-cart-page]')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-discount-apply], [data-discount-remove]');
    if (!button) return;
    apply(button.closest('[data-cart-discount]'), button.dataset.discountRemove);
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Enter' && e.target.matches('[data-discount-input]')) {
      e.preventDefault();
      apply(e.target.closest('[data-cart-discount]'));
    }
  });
  document.addEventListener('cartuja:cart-render', e => paint(e.detail));
  fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.ok ? r.json() : Promise.reject()).then(paint).catch(() => {});
})();
